// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 869) return "static/chunks/styles-ff1d10abb995f043.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"640":"e4d89eeecb382617","729":"33c8a4376e44b249","818":"9eef6f713641f993","852":"5ea5baa86931952e"}[chunkId] + ".js";
};